import { render, staticRenderFns } from "./hotelOrderInfo.vue?vue&type=template&id=279abdca&"
import script from "./hotelOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./hotelOrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./hotelOrderInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports